import React from 'react';
import { X } from 'lucide-react';

/**
 * ActiveFilterChips - Displays active filters with individual removal
 * Per Filter Doctrine: All active constraints must be externally visible and removable
 */
const ActiveFilterChips = ({ chips, onRemove, onClearAll }) => {
  if (!chips || chips.length === 0) return null;
  
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <span className="text-sm text-gray-600 font-medium">Active filters:</span>
      
      {chips.map((chip) => (
        <button
          key={chip.key}
          onClick={() => onRemove(chip)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#1a5d3a]/10 text-[#1a5d3a] rounded-full text-sm font-medium hover:bg-[#1a5d3a]/20 transition-colors group"
        >
          <span>{chip.label}</span>
          <X 
            size={14} 
            className="text-[#1a5d3a]/60 group-hover:text-[#1a5d3a]" 
          />
        </button>
      ))}
      
      {chips.length > 1 && (
        <button
          onClick={onClearAll}
          className="text-sm text-gray-500 hover:text-gray-700 underline ml-2"
        >
          Clear all
        </button>
      )}
    </div>
  );
};

export default ActiveFilterChips;
